import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Maps from '../../store/map';
import { Translate } from '../../localization';

function Header(props) {
    const changeLanguage = (e) => {
        Translate.setLanguage(e.currentTarget.id);
        props.setLanguage(Translate.getLanguage());
    };

    const getDropdownItem = (id) => {
        let { language } = props.general;
        return id === language ? (
            <Dropdown.Item id={id} active onClick={changeLanguage}>
                {Translate[id]}
            </Dropdown.Item>
        ) : (
            <Dropdown.Item id={id} onClick={changeLanguage}>
                {Translate[id]}
            </Dropdown.Item>
        );
    };

    let { language } = props.general;

    return (
        <div className="container header-fix bg-green pt-2 pb-2 clearfix" style={{ zIndex: '1198' }}>
            <span className="float-left fs-22 text-white font-weight-bold disable-select" onClick={(e) => props.GoToPage('')}>
                {/* <img src={Logo} className="logo" /> */}

                <i className="icon-effebet-logo"></i>
                {/* effebet */}
            </span>
            <span className="float-right fs-22">
                <Dropdown>
                    <Dropdown.Toggle as={Dropdown} id="dropdown-custom-components">
                        {Translate[language]}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {getDropdownItem('en')}
                        {getDropdownItem('fr')}
                        {getDropdownItem('tr')}
                        {getDropdownItem('de')}
                    </Dropdown.Menu>
                </Dropdown>
            </span>
        </div>
    );
}

export default connect(Maps.mapGeneralStateToProps, Maps.mapGeneralDispatchToProps)(Header);
